import { render, staticRenderFns } from "./PromoStep1.vue?vue&type=template&id=2141855e"
import script from "./PromoStep1.vue?vue&type=script&lang=js"
export * from "./PromoStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports